import { render } from "./AppFooter.vue?vue&type=template&id=4eb0aeaa&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=4eb0aeaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb0aeaa"]])

export default __exports__